import { decorate, observable, flow } from 'mobx';

import { workOrderFigureListUrl } from './APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

export default class FigureListStore {

    workOrderId = -1;

    figureList = [];
    listState = PENDING;
    rowCount = 0;
   
    constructor(props) {
        this.apiProxy = props.apiProxy;
    }

    fetchFigureList = flow(function* () {
        this.listState = PENDING;
        try {

            const url = workOrderFigureListUrl.replace('{id}',this.workOrderId);
            const response = yield this.apiProxy.getAsync(url);
            const data = yield response.json();

            this.figureList = data;
            this.rowCount = data.length;
            this.listState = DONE;

        }
        catch (e) {
            this.listState = ERROR;
        };
    });
}

decorate(FigureListStore, {
    listState: observable,
    figureList: observable,
    rowCount: observable,
    workOrderId: observable
})